<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                   <template slot="BodyFormLoad">
                       <div class="container-fluid">
                           <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                            <label class="form-label" for="Nombre">Nombre</label>
                                            <input type="text" v-model="objPaqueteSistema.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
                                            <CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                                            <label class="form-label" for="Precio">Precio</label>
                                            <input @input="$number_decimal($event,objPaqueteSistema,'Precio')" type="text" v-model="objPaqueteSistema.Precio" class="form-control" id="Precio" placeholder="Ingresar Precio" />
                                            <CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                            <label class="form-label" for="Vigencia">Vigencia</label>
                                            <div class="row form-group">
                                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="d-flex align-items-center">
                                                        <label for="VigenciaTipo" class="me-2">Período: </label>
                                                        <select id="VigenciaTipo" name="VigenciaTipo" @change="CalcularVigencia()" v-model="objVigencia.Tipo" class="form-control form-select">
                                                            <option value="anio">Años</option>
                                                            <option value="mes">Meses</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="d-flex align-items-center">
                                                        <label for="VigenciaCant" class="me-2">Cantidad:</label>
                                                        <input type="text" @input="$onlyNums($event,objVigencia,'Cantidad');CalcularVigencia()" v-model="objVigencia.Cantidad" class="form-control" id="VigenciaCant" placeholder="Ingresar Cantidad" />
                                                    </div>
                                                    <CValidation v-if="this.errorvalidacion.Vigencia" :Mensaje="'*'+errorvalidacion.Vigencia[0]"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                            <label class="form-label" for="Estatus">Estatus</label>
                                            <div class="form-check">
                                                <input v-model="CheckEstatus" @change="ActualizarEstatus()" name="Estatus" id="Estatus" type="checkbox" class="form-check-input">
                                                <span v-if="objPaqueteSistema.Estatus==='Activo'">Activo</span>
                                                <span v-else>Inactivo</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <h6>Módulos Sistema Agregados</h6>
                                                <button type="button" class="btn btn-sm btn-primary" @click="AbrirModulosSistema()"><i class="fas fa-plus"> Agregar</i></button>
                                            </div>
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="table-responsive">
                                                        <CLoader :pConfigLoad="ConfigLoadDetallesModulo">
                                                            <template slot="BodyFormLoad">
                                                                <table class="table align-items-center mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th :class="StyleTh+' text-center'">#</th>
                                                                            <th :class="StyleTh" width="60%">Nombre</th>
                                                                            <th :class="StyleTh">Acciones</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(lista,index) in ListaPaqueteSistemaDetalles" :key="index">
                                                                            <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                                            <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                                                            <td class="align-middle text-center">
                                                                                <button @click="VerDetallesModulo(lista.IdModuloSistema)" class="btn btn-link text-primary px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="fas fa-eye text-primary me-2"></i>Ver Detalles</button>
                                                                                <button @click="EliminarModuloSistema(index)" class="btn btn-link text-danger px-3 mb-0 mr-1" type="button"><i aria-hidden="true" class="far fa-trash-alt me-2"></i>Eliminar</button>
                                                                            </td>
                                                                        </tr>
                                                                        <CSinRegistros :pContIF="ListaPaqueteSistemaDetalles.length" :pColspan="6"></CSinRegistros>
                                                                    </tbody>
                                                                </table>
                                                            </template>
                                                        </CLoader>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                
                                        <div class="col-lg-6">
                                            <div class="pb-3">
                                                <h6>Detalles del Módulo Sistema</h6>
                                            </div>
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="table-responsive">
                                                        <CLoader :pConfigLoad="ConfigLoadDetallesModuloSistema">
                                                            <template slot="BodyFormLoad">
                                                                <table class="table align-items-center mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th :class="StyleTh+' text-center'">#</th>
                                                                            <th :class="StyleTh" width="90%">Nombre</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(lista,index) in ListaModuloDetalle" :key="index">
                                                                            <td class="text-center"><p :class="StyleTd">{{ (index+1) }}</p></td>
                                                                            <td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                                                                        </tr>
                                                                        <CSinRegistros :pContIF="ListaModuloDetalle.length" :pColspan="6"></CSinRegistros>
                                                                    </tbody>
                                                                </table>
                                                            </template>
                                                        </CLoader>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                           </div>
                       </div>
                       <CBtnSave :poBtnSave="oBtnSave" />
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave2">
            <template slot="Form">
                <Form :poBtnSave="oBtnSave2"></Form>
            </template>
        </CModal>
    </div>
</template>

<script>
const EmitEjecuta = 'FormModuloSitema'
const EmitEjecuta2 = 'ListModuloSistema'
import Configs from '@/helpers/VarConfig.js';
import Form from '@/views/modulos/root/paquetessistema/ListModulosSistema.vue';

import moment from 'moment';
export default {
    name: 'FormModuloSistema',
    props: ['Id'],
    components:{Form},
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
            ConfigListModulosSistema:{
                Title:'Módulos Sistema',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: true,
                ShowFooter: false,
            },
			ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
			ConfigLoadDetallesModulo:{
                ShowLoader: false,
                ClassLoad: false,
            },
			ConfigLoadDetallesModuloSistema:{
                ShowLoader: false,
                ClassLoad: false,
            },
            objPaqueteSistema: {
				IdPaqueteSistema: 0,
				Nombre: '',
				Precio: '',
				Vigencia: '',
				Estatus: 'Activo',
            },
            objVigencia:{
                Tipo:'mes',
                Cantidad:'',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar...',
                Menu:'',
                SubMenu:'',
                Apartado:'',
                IdAsociado:0,
                TipoMenu:'',
            },
            ConfigModal:{
                ModalTitle: "Módulos Sistema",
                ModalNameId: 'ModalFormMS',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
                ShowFooter: false,
            },
            oBtnSave2:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
				ActiveEmitReturn: true,
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'paquetesSistema',
                EmitSeccion: EmitEjecuta,
				ActiveEmitReturn: true,
            },
            CheckEstatus:true,
            DetalleModuloActual:0,
            segurity: {},
            obj: {},
            ListaModuloDetalle: [],         
            ListaPaqueteSistemaDetalles: [],
            PanelesMenu: [],
            IdPaqueteSistema:0,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            errorvalidacion: [],
			Emit: EmitEjecuta,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
            if (this.ListaPaqueteSistemaDetalles.length <= 0){
                this.$toast.warning('Es necesario agregar módulos.');
                this.oBtnSave.DisableBtn = false;
                return false;
            }

			if(this.objPaqueteSistema.IdPaqueteSistema == 0) {
				await this.$http.post(
					'paquetesSistema',{...this.objPaqueteSistema,
                        ListaPaqueteSistemaDetalles:this.ListaPaqueteSistemaDetalles
                    }
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'paquetesSistema/'+this.objPaqueteSistema.IdPaqueteSistema,
					{...this.objPaqueteSistema,
                        ListaPaqueteSistemaDetalles:this.ListaPaqueteSistemaDetalles
                    }
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
        AgregarModulo(moduloSistema){
            this.bus.$emit('CloseModal_'+EmitEjecuta2);
            let isAdded = this.ListaPaqueteSistemaDetalles.some(elem => elem.IdModuloSistema == moduloSistema.IdModuloSistema);
            if (isAdded){
                this.$toast.error('Módulo Sistama ya ha sido Agregado')
            } else {
                let newDetalleModulo = {
                    IdPaqueteSistemaDetalle:0,
                    IdPaqueteSistema:0,
                    IdModuloSistema:moduloSistema.IdModuloSistema,
                    Nombre:moduloSistema.Nombre,
                    TipoMenu:'',
                }
                this.ListaPaqueteSistemaDetalles.push(newDetalleModulo);
            }
        },
        EliminarModuloSistema(index){
            this.ListaPaqueteSistemaDetalles.splice(index,1)
        },
        AbrirModulosSistema(){
            this.bus.$emit('NewModal_'+EmitEjecuta2,[...this.ListaPaqueteSistemaDetalles]);
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        ActualizarEstatus(){
            if(this.CheckEstatus){
                this.objPaqueteSistema.Estatus = 'Activo';
            } else {
                this.objPaqueteSistema.Estatus = 'Inactivo';
            }
        },
        CalcularVigencia(){
            let calcVigencia = 0;
            if (this.objVigencia.Tipo === 'anio'){
                calcVigencia = this.objVigencia.Cantidad * 12;
            } else {
                calcVigencia = this.objVigencia.Cantidad * 1;
            }
            this.objPaqueteSistema.Vigencia = isNaN(calcVigencia) ? '0' : String(calcVigencia);
        },
        VerDetallesModulo(idModuloSistema){
            this.ConfigLoadDetallesModuloSistema.ShowLoader = true;
            this.$http.get(
            "modulosSistema/"+idModuloSistema
            ).then((res) => {
                this.ListaModuloDetalle = res.data.Detalles;
            }).finally(()=>{
                this.ConfigLoadDetallesModuloSistema.ShowLoader = false;
            }).catch(err => console.error(err))
        },
		Recuperar()
        {
            this.$http.get(
                "paquetesSistema/"+this.objPaqueteSistema.IdPaqueteSistema
            ).then((res) => {
                this.objPaqueteSistema = res.data.data;
                this.ListaPaqueteSistemaDetalles = res.data.Detalles;
                this.objVigencia.Tipo = 'mes';
                this.objVigencia.Cantidad = res.data.data.Vigencia;
                if (this.objPaqueteSistema.Estatus === 'Activo'){
                    this.CheckEstatus = true;
                } else {
                    this.CheckEstatus = false;
                }
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            }).catch(err => console.error(err));
        },
        Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{}});
        },
        Limpiar()
        {
            this.objPaqueteSistema = {
				IdPaqueteSistema: 0,
				Nombre: '',
				Precio: '',
				Vigencia: '',
				Estatus: 'Activo',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;
        if(this.Id != undefined){
            sessionStorage.setItem('IdIdPaqueteSistema',JSON.stringify(this.Id));
        }
        this.IdPaqueteSistema = JSON.parse(sessionStorage.getItem('IdIdPaqueteSistema'));

        this.bus.$off('EmitReturn');
        this.bus.$off('AgregarModuloSistema');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.IdPaqueteSistema!='') 
        {
            this.objPaqueteSistema.IdPaqueteSistema = this.IdPaqueteSistema;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
        this.bus.$on('AgregarModuloSistema',(ModuloSistema)=>
        {
            this.AgregarModulo(ModuloSistema);
        });
    }
}
</script>
